import { GetStaticPaths, GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { PricingPage } from '@/pages/Pricing';
import { paymentModel } from '@/entities/payment';
import { deviceType, timeInSeconds } from '@/shared/constants';
import { getPaths, parseSSGParams } from '@/shared/helpers';
import { checkRequestErrors } from '@/shared/utils';
import { i18n } from '../../../next-i18next.config';

export const getStaticProps: GetStaticProps = async (context) => {
  const { device } = parseSSGParams(context.params);

  const isValidPath = Object.values(deviceType).includes(device);
  if (!isValidPath) {
    return {
      notFound: true,
    };
  }

  const { tariffs, ssrCache } = await paymentModel.getTariffsList();

  const { revalidate, urqlState } = checkRequestErrors(ssrCache.extractData(), timeInSeconds.WEEK);

  return {
    props: {
      ...(await serverSideTranslations(context.locale || i18n.defaultLocale, ['common'])),
      tariffs: tariffs || null,
      urqlState,
    },
    revalidate,
  };
};

export const getStaticPaths: GetStaticPaths = async (_context) => {
  return {
    paths: getPaths(),
    fallback: 'blocking',
  };
};

export default PricingPage;
